<template>
  <b-overlay 
    :show="(details == null || isBusy)" 
    variant="dark" 
  >
    <b-button
      :to="{ name: 'VerwerkteDocumenten', params: { jaar: jaar } }"
      variant="link"
    >
      <font-awesome-icon icon="arrow-left" /> Alle documenten van {{ jaar }}
    </b-button>
    
    <b-row 
      v-if="details"
    >
      <b-col>
        <!-- <b-input 
          v-model="height"
          :min="400" 
          :max="600" 
          type="range" />-->
        <b-card 
          v-if="details" 
        > 
          <b-card-title>
            DOCUMENT {{ details.Type.Omschrijving.toUpperCase() }} 
          <!-- {{ docEndpoint }}  -->
          </b-card-title>
        
          <b-card-sub-title class="mb-3">
            <b-link 
              v-for="unit in details.Units" 
              :key="unit.Id"
              :to="{name:'UnitViewRoute',params:{id:unit.Id}}"
            >
              {{ unit.UnitKenmerk }} {{ unit.Adres }} {{ unit.WijkPlaats }}
            </b-link> 
            
            <b> {{ details.RelatieBedrijf != null ? details.RelatieBedrijf.Naam : "Geen" }}</b>
          </b-card-sub-title>

          <b-tabs @changed="onChangeTab">
            <b-tab 
              title="ALGEMEEN" 
            >
              <b-form-group label="Type Document">
                <b-input-group>
                  <b-select 
                    v-model="details.Type" 
                    :options="doctypes"
                  >
                    {{ details.Type }}
                  </b-select>
                  <b-input-group-append is-text>
                    <b-check 
                      v-model="details.DocumentTonen"
                    >
                      Zichtbaar voor klant
                    </b-check>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group label="Kenmerk">
                <b-input
                  v-model="details.Kenmerk"
                  debounce="500"
                  maxlength="100"
                  placeholder="Kenmerk van document"
                />
                <document-kenmerk 
                  v-if="details.Afzender !== null && !isKeuringsDocument"
                  :current-id="details.Id"
                  :relatie-id="details.Afzender.Id" 
                  :kenmerk="details.Kenmerk"
                />
              </b-form-group>
              <b-form-group label="Status">
                <b-radio-group
                  v-if="!isKeuringsDocument"
                  v-model="details.Status"
                  :options="statussen"
                  button-variant="outline-primary"
                  buttons
                  @change="updateEmail"
                />
                <b-alert 
                  v-else 
                  variant="warning" 
                  show
                >
                  Zie voor de keuringsstatus de unit! (In een latere update zal dit bij de tab Units in te zien en direct te wijzigen zijn.)
                </b-alert>
              </b-form-group>

              <b-form-group 
                v-if="isTerControle"
                label="Beoordelaar"
                description="Verplicht bij de status 'Ter controle'."
              >
                <inspecteur-select
                  :value="details.Beoordelaar"
                  :required="true"
                  :allow-beheerders="true"
                  :eigen-groep-alleen="true"
                  @input="onBeoordelaarInput"
                />
                <b-form-invalid-feedback :state="details.Beoordelaar != null">
                  Kies een beoordelaar; dit is verplicht bij de status 'Ter controle'.
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="Datum">
                <b-datepicker v-model="details.Datum" />
              </b-form-group>

              <b-form-group label="Datum stempel/verzenddatum">
                <b-datepicker v-model="details.Verzenddatum" />
              </b-form-group>

              <b-form-row>
                <b-col>
                  <b-form-group label="Omschrijving">
                    <b-input v-model="details.Omschrijving" />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Bedrag">
                    <b-input v-model.number="details.Bedrag" />
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-group label="Afzender">
                <b-select
                  v-if="relaties.length > 0"
                  v-model="details.Afzender"
                  :options="
                    relaties.map((r) => {
                      return { value: r, text: r.Naam };
                    })
                  "
                  :state="details.Afzender != null"
                />
              </b-form-group>

              <b-alert 
                :show="!hasAfzender" 
                variant="danger"
              >
                Vul aub een afzender in!
              </b-alert>
             
              <b-form-group label="Relatie">
                <b-input-group>
                  <b-select
                    v-if="relaties.length > 0"
                    v-model="details.RelatieBedrijf"
                    :options="
                      relaties.map((r) => {
                        return { value: r, text: r.Naam };
                      })
                    "
                    @change="changeRelatie($event)"
                  />
                
                  <b-select
                    v-if="contactpersonen.length > 0"
                    v-model="details.Relatie"
                    :options="
                      contactpersonen.map((r) => {
                        return { value: r, text: r.Naam };
                      })
                    "
                    :state="details.RelatieBedrijf !== null && details.Relatie !== null"
                  />
                  <b-button 
                    v-else 
                    :disabled="fetchingContactpersonen"
                    @click="changeRelatie(details.RelatieBedrijf)"
                  >
                    <i class="fa fa-user" /> Selecteer een contactpersoon 
                    <!--- rotating refresh icon -->
                    <b-spinner 
                      v-if="fetchingContactpersonen" 
                      small 
                      variant="light"
                    />
                  </b-button>
                </b-input-group>
              </b-form-group>
              <b-alert 
                :show="!hasRelatie" 
                variant="danger"
              >
                Vul aub een contactpersoon in!
              </b-alert>
              <b-form-group label="Soort onderhoud">
                <b-radio-group
                  v-model="details.SoortOnderhoud"
                  :options="onderhoudsoorten"
                  button-variant="outline-primary"
                  buttons
                />
              </b-form-group>

              <b-button-toolbar class="mt-4">
                <b-button
                  :disabled="!canSave"
                  variant="success"
                  class="mr-2"
                  @click="DocumentOpslaan"
                >
                  <i 
                    v-if="!isBusy" 
                    class="fa fa-save mr-1"
                  />
                  <b-spinner
                    v-else
                    size="sm"
                    small
                    class="mx-1"
                    role="status"
                    variant="secondary"
                  />Opslaan
                </b-button>
                <b-button 
                  :id="docDeleteId" 
                  variant="danger"
                >
                  <i class="fa fa-trash mr-1" /> Verwijderen
                </b-button>
                <b-popover
                  ref="popoverVerwijderen"
                  :target="docDeleteId"
                  triggers="click focus"
                  placement="right"
                >
                  <template #title>
                    Zeker weten?
                  </template>
                  <b-button
                    variant="danger"
                    class="mr-2"
                    @click="DocumentVerwijderen"
                  >
                    Ja
                  </b-button>
                  <b-button
                    variant="success"
                    @click="$refs.popoverVerwijderen.$emit('close')"
                  >
                    Nee
                  </b-button>
                </b-popover>
              </b-button-toolbar>
            </b-tab>

            <b-tab 
              v-if="details.Units" 
              title="UNITS"
            >
              <b-table
                :items="details.Units"
                :fields="['Id', 'Kenmerk', 'Adres', 'WijkPlaats']"
                bordered
              >
                <template #cell(Id)="row">
                  <b-check v-model="row.item.selected" />
                </template>
              </b-table>

              <b-button 
                :disabled="selectie.length == 0" 
                @click="UnitsVerwijderen"
              >
                Unit verwijderen
              </b-button>

              <unit-selectie 
                :units="units" 
                @selected="AddUnits"
              />
            </b-tab>

            <b-tab title="OPMERKINGEN">
              <document-opmerkingen
                :opmerkingen="details.Opmerkingen"
                :document="details"
              />
            </b-tab>
          
            <b-tab 
              v-if="!isKeuringsDocument" 
              title="E-MAIL" 
              class="clearfix"
            >
              <b-modal
                v-model="stempelPositieDialog"
                :ok-disabled="!heeftStempel"
                title="Kenmerken stempel"
                ok-title="Toon voorbeeld"
                @ok="previewFile"
              >
                <b-form-group label="Stempel">
                  <b-input-group 
                    prepend="Doorzichtigheid" 
                    class="mb-2"
                  >
                    <b-form-input
                      v-model.number="opacity"
                      type="range"
                      min="0"
                      max="1"
                      step=".1"
                    />
                  </b-input-group>
                  <b-form-row>
                    <b-col>
                      <b-input-group prepend="Onder offset">
                        <b-form-input
                          v-model.number="bottom"
                          type="number"
                          min="0"
                          max="200"
                          step="1"
                        />
                      </b-input-group>
                    </b-col>
                    <b-col>
                      <b-input-group prepend="Links offset">
                        <b-form-input
                          v-model.number="left"
                          type="number"
                          min="0"
                          max="200"
                          step="1"
                        />
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                </b-form-group>
              </b-modal>

              <b-form-group 
                label="Aan"
                description="Typ een e-mailadres en druk op Enter, of kies uit de suggesties (afzender, relatie en geconfigureerde document-routering)."
              >
                <multiselect
                  v-model="mail.ontvangers"
                  :options="ontvangerSuggesties"
                  :multiple="true"
                  :taggable="true"
                  :close-on-select="false"
                  :hide-selected="true"
                  track-by="email"
                  label="label"
                  tag-placeholder="Druk op Enter om toe te voegen"
                  placeholder="E-mailadres typen of selecteren..."
                  @tag="addRecipientTag"
                />
                <b-form-invalid-feedback :state="!tagError">
                  {{ tagError }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="Onderwerp">
                <b-input
                  v-model="mail.onderwerp"
                  placeholder="Onderwerp van de email"
                />
              </b-form-group>

              <b-form-group label="Bericht">
                <b-textarea 
                  v-model="mail.bericht" 
                  rows="5"
                />
              </b-form-group>

              <b-button
                id="stempel_button"
                :disabled="(heeftStempel == null)"
                size="lg"
                class="my-3"
                variant="primary"
                @click="stempelPositieDialog = true"
              >
                Voorbeeld stempel
                <font-awesome-icon icon="stamp" />
              </b-button>

              <b-alert 
                :show="(heeftStempel == null)"
              >
                {{ details.Status.Omschrijving }} heeft geen stempel!
              </b-alert>

              <b-form-group :description="uploadAPIPath">
                <label>Bijlagen</label>

                <b-list-group>
                  <b-list-group-item
                    v-for="(item, index) in details.Details.Bijlagen"
                    :key="item.public_id"
                    class="mb-3"
                  >
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">
                        <i class="fa fa-paperclip" />
                        {{ item.original_filename }}.{{ item.format }}
                      </h5>
                      <small>
                        <b-button
                          class="btn btn-sm btn-danger"
                          @click="VerwijderBijlagen(index)"
                        >
                          <i class="fa fa-trash" />&nbsp;Verwijderen
                        </b-button>
                      </small>
                    </div>
                    <p class="mb-1">
                      {{ item.pages }}
                      {{ item.pages == 1 ? "pagina" : "pagina's" }}
                    </p>
                    <small>{{ formatBytes(item.bytes) }}</small>
                  </b-list-group-item>
                </b-list-group>

                <upload-file
                  :folder="uploadAPIPath"
                  cloud="tranpslan"
                  preset="hxdb54hj"
                  @file-uploaded="
                    details.Details.Bijlagen.push($event);
                    DocumentOpslaan();
                  "
                />
              </b-form-group>

              <b-alert 
                :show="(boodschap != null)" 
                variant="success"
              >
                {{
                  boodschap
                }}
              </b-alert>

              <b-button
                :disabled="!canSend || sending"
                variant="primary"
                size="lg"
                class="pull-right "
                @click="sendFileWithStamp"
              >
                <font-awesome-icon
                  v-if="!sending"
                  icon="paper-plane"
                  class="mx-1"
                />

                <b-spinner
                  v-else
                  :small="true"
                  size="sm"
                  class="mx-1"
                  role="status"
                  variant="secondary"
                />
                {{ recipients.length }} VERSTUREN
              </b-button>

              <!-- Verzendhistorie -->
              <div 
                v-if="verzendHistorie.length > 0" 
                class="mt-5 clearfix"
              >
                <h5>
                  <font-awesome-icon icon="history" class="mr-1" /> Verzendhistorie
                </h5>
                <b-table
                  :items="verzendHistorie"
                  :fields="[
                    { key: 'Datum', label: 'Verzonden op', formatter: formatHistorieDatum },
                    { key: 'Aan', label: 'Ontvangers' },
                    { key: 'Onderwerp', label: 'Onderwerp' },
                    { key: 'Status', label: 'Status' },
                  ]"
                  small
                  bordered
                >
                  <template #cell(Aan)="row">
                    <div 
                      v-for="adres in row.item.Aan" 
                      :key="adres"
                    >
                      <b-badge 
                        variant="secondary"
                        class="mr-1"
                      >
                        {{ adres }}
                      </b-badge>
                      <b-badge
                        v-if="laatsteEventVoor(row.item, adres)"
                        :variant="eventVariant(laatsteEventVoor(row.item, adres).EventType)"
                        :title="formatHistorieDatum(laatsteEventVoor(row.item, adres).Datum)"
                      >
                        {{ laatsteEventVoor(row.item, adres).EventType }}
                      </b-badge>
                    </div>
                  </template>
                  <template #cell(Status)="row">
                    <span 
                      v-if="row.item.Geaccepteerd" 
                      class="text-success"
                    >
                      <font-awesome-icon icon="check-circle" /> geaccepteerd
                    </span>
                    <span 
                      v-else 
                      class="text-danger"
                    >
                      <font-awesome-icon icon="times-circle" /> fout
                    </span>
                  </template>
                </b-table>
              </div>
            </b-tab>
            <!-- <b-tab title="JSON">
              <pre class="text-white">{{ details }}</pre>
            </b-tab> -->
          </b-tabs>
        </b-card>
      </b-col>
      <b-col :style="{'min-height':height+'px','z-index':0}">
        <vue-pdf-app 
          :pdf="renderedDoc || details.FileMetadata.secure_url" 
          :file-name="details.Filename" 
          theme="dark"
        />
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>

import { serviceMixin } from "@/mixins/serviceMixin";
import { documentMixin } from "@/mixins/documentMixin";
import { PDFDocument, StandardFonts } from "pdf-lib";
import DocumentOpmerkingen from "@/components/document/DocumentOpmerkingen";
import UnitSelectie from "@/components/UnitSelectie";
import UploadFile from "@/components/UploadFile";
import "vue-pdf-app/dist/icons/main.css";
import VuePdfApp from "vue-pdf-app";
import DocumentKenmerk from "@/views/administratie/documenten/DocumentKenmerk.vue";
import Multiselect from "vue-multiselect";
import InspecteurSelect from "@/components/InspecteurSelect";

export default {
  components: {
    UnitSelectie,
    DocumentOpmerkingen,
    UploadFile,
    DocumentKenmerk,
    VuePdfApp,
    Multiselect,
    InspecteurSelect,
  },
  mixins: [serviceMixin, documentMixin],
  props: {
    doc: {
      type: Object,
      default: () => {
        return {
          Ty: "Geen",
          Un: "Onbekend",
        };
      },
    },
    relaties: {
      type: Array,
      default: () => [],
    },
    units: {
      type: Array,
      default: () => [],
    },
    jaar: {
      type: Number,
      default: new Date().getUTCFullYear(),
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      bottom: 180,
      height: 600,
      profiel: null,
      isBusy: false,
      left: 50,
      fontSize: 10,
      currentPage: 1,
      contactpersonen: [],
      opacity: 0.8,
      boodschap: null,
      sending: null,
      mail: {
        bericht: null,
        onderwerp: null,
        ontvangers: [],
      },
      tagError: null,
      fetchingContactpersonen: false,
      stempelPositieDialog: false,
      renderedDoc: null,
      details: null,
      typeOnderhoud: [
        "Correctief",
        "Diverse",
        "Keuringen",
        "Planmatig",
        "Preventief",
      ],
      typeStatus: [
        "Afgekeurd",
        "Ter controle",
        "Goedgekeurd",
        "Opdracht",
        "Afgerond",
      ],
    };
  },
  computed: {
    isKeuringsDocument: function () {
      if (this.details == null) return false;
      return this.details.Type.Id === 5;
    },
    heeftStempel: function () {
      return this.stempels[this.details.Status.Omschrijving];
    },
    uploadFolder: function () {
      return this.profiel
        ? this.profiel.auth.user.Bedrijf.Naam.toLowerCase()
        : "nosli";
    },
    uploadAPIPath: function () {
      return `${
        this.uploadFolder
      }/${new Date().getUTCFullYear()}/documentbijlagen`;
    },
    stempels: function () {
      return {
        Goedgekeurd: `https://res.cloudinary.com/transplan/image/upload/v1489669317/stempels/${this.uploadFolder}_goedgekeurd.png`,
        Afgekeurd: `https://res.cloudinary.com/transplan/image/upload/v1489669320/stempels/${this.uploadFolder}_afgekeurd.png`,
      };
    },
    recipients: function () {
      return (this.mail.ontvangers || [])
        .map((o) => o.email)
        .filter((e) => this.validEmail(e));
    },
    // Suggesties voor het "Aan" veld: afzender, relatie contact & documentRoutering
    ontvangerSuggesties: function () {
      var list = [];
      if (this.details && this.details.Afzender && this.validEmail(this.afzenderEmail)) {
        list.push({
          email: this.afzenderEmail,
          label: `${this.details.Afzender.Naam} (${this.afzenderEmailBron}) <${this.afzenderEmail}>`,
        });
      }
      if (this.details && this.details.Relatie && this.relatieEmailInfo && this.validEmail(this.relatieEmailInfo.email)) {
        list.push({
          email: this.relatieEmailInfo.email,
          label: `${this.details.Relatie.Bedrijf.Naam} (${this.relatieEmailInfo.bron}) <${this.relatieEmailInfo.email}>`,
        });
      }
      (this.documentRoutes || []).forEach((route) => {
        if (this.validEmail(route.email)) {
          list.push({
            email: route.email,
            label: `${route.naam || route.email} <${route.email}>`,
          });
        }
      });
      // eigen account als optie
      var eigen = this.$store.state.user.username;
      if (this.validEmail(eigen)) {
        list.push({ email: eigen, label: `Mijzelf <${eigen}>` });
      }
      // ontdubbelen op email
      var seen = {};
      return list.filter((o) => {
        if (seen[o.email]) return false;
        seen[o.email] = true;
        return true;
      });
    },
    canSend: function () {
      // alle chips moeten geldige e-mailadressen zijn en minstens 1 ontvanger
      var all = this.mail.ontvangers || [];
      return all.length > 0 && all.every((o) => this.validEmail(o.email));
    },
    verzendHistorie: function () {
      if (!this.details) return [];
      return this.details.VerzendHistorie || [];
    },
    isTerControle: function () {
      if (!this.details || !this.details.Status) return false;
      return (this.details.Status.Omschrijving || "").toLowerCase() === "ter controle";
    },
    canSave: function () {
      if (this.isTerControle && this.details.Beoordelaar == null) return false;
      return this.hasAfzender && (this.hasRelatie || this.details.RelatieBedrijf !== null);
    },
    hasAfzender: function () {
      return this.details.Afzender !== null;
    },
    hasRelatie: function () {
      return this.details.Relatie !== null;
    },
    selectie: function () {
      if (this.details === null) return [];
      return this.details.Units.filter((i) => i.selected);
    },
    docDeleteId: function () {
      return `doc-delete-${this.id}`;
    },
    docEndpoint: function () {
      return `/documenten/document/${this.id}`;
    },
    onderhoudsoorten: function () {
      return this.typeOnderhoud.map((item) => {
        return { text: item, value: item.substr(0, 2).toUpperCase() };
      });
    },
    statussen: function () {
      return this.typeStatus.map((item, index) => {
        return { text: item, value: { Omschrijving: item, Id: index } };
      });
    },
    doctypes: function () {
      return this.typeDocs.map((item) => {
        return {
          text: item.text,
          value: { Omschrijving: item.text, Id: item.value },
        };
      });
    },
    relatieEmail: function () {
      return this.relatieEmailInfo ? this.relatieEmailInfo.email : undefined;
    },
    // Bepaalt het relatie e-mailadres inclusief de bron (soort onderhoud of financieel)
    relatieEmailInfo: function () {
      if (!this.details || !this.details.Relatie) return null;
      var addressen = this.details.Relatie.Bedrijf.Config.emailadressen || {};
      var soort = this.details.SoortOnderhoud;
      if (Object.prototype.hasOwnProperty.call(addressen, soort)) {
        var entry = addressen[soort];
        var omschrijving = (entry.type && entry.type.omschrijving) || soort;
        return { email: entry.adres, bron: omschrijving };
      }
      return {
        email: this.details.Relatie.Bedrijf.FinEmail,
        bron: "Financiële administratie",
      };
    },
    afzenderEmail: function () {
      return this.details.Afzender.FinEmail || this.details.Afzender.Email;
    },
    afzenderEmailBron: function () {
      if (!this.details || !this.details.Afzender) return "";
      return this.details.Afzender.FinEmail
        ? "Financiële administratie"
        : "Algemeen";
    },
    // Alle "documentRoutering" regels uit de Config van de RelatieBedrijf.
    // Een regel "matched" wanneer minstens één Unit van het document onder een
    // van de geselecteerde complexen valt (route.complexIds bevat unit.ComplexId).
    documentRoutes: function () {
      if (!this.details || !this.details.RelatieBedrijf) return [];
      var cfg = this.details.RelatieBedrijf.Config || {};
      var routes = cfg.documentRoutering || [];
      var docUnits = (this.details.Units || []);
      // Verzamel alle ComplexIds van de documenten-units (indien aanwezig)
      var docComplexIds = docUnits
        .map((u) => u.ComplexId || (u.Complex && u.Complex.Id))
        .filter((id) => id != null);

      return routes
        .filter((r) => r && r.email)
        .map((r) => {
          var complexIds = r.complexIds || [];
          // Match: geen complex-filter ingesteld OF tenminste 1 overlap
          var matched = complexIds.length === 0 || docComplexIds.some((id) => complexIds.indexOf(id) > -1);
          return Object.assign({}, r, { matchesDocument: matched && r.autofill });
        });
    },
    bericht: function () {
      if (this.details === null) return "";
      return `Het document '${
        this.details.Kenmerk
      }' is ${this.details.Status.Omschrijving.toUpperCase()}`;
    },
    onderwerp: function () {
      if (this.details === null) return "";
      return `Uw poststuk met kenmerk ${
        this.details.Type.Omschrijving
      } ${this.details.Kenmerk} is ${this.details.Status.Omschrijving.toUpperCase()}.`;
    },
  },
  watch: {
    "details.Kenmerk": function () {
      this.updateEmail();
    },
    "details.Status": function () {
      this.updateEmail();
    },
    // Autofill: voeg matchende routes automatisch als chips toe aan het Aan-veld
    documentRoutes: {
      immediate: true,
      handler() {
        this.applyAutofillRoutes();
      },
    },
  },
  mounted() {
    this.getDocumentDetails();
    this.getProfile();
  },
  methods: {
    onChangeTab(tab) {
      console.log(tab);
      console.log(window.innerHeight);
      this.height = window.innerHeight - 315 ;
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    // Pas de autofill routes toe op het Aan-veld (matchende documentRoutering regels)
    applyAutofillRoutes() {
      (this.documentRoutes || []).forEach((r) => {
        if (r.matchesDocument && this.validEmail(r.email)) {
          this.addRecipient({
            email: r.email,
            label: `${r.naam || r.email} <${r.email}>`,
          });
        }
      });
    },
    // Voeg een ontvanger toe (indien niet reeds aanwezig)
    addRecipient(recipient) {
      var exists = (this.mail.ontvangers || []).some(
        (o) => o.email.toLowerCase() === recipient.email.toLowerCase()
      );
      if (!exists) this.mail.ontvangers.push(recipient);
    },
    // Vrije invoer via Enter — Outlook-stijl, met e-mailvalidatie
    addRecipientTag(newTag) {
      var email = (newTag || "").trim().replace(/[;,]$/, "");
      if (!this.validEmail(email)) {
        this.tagError = `'${email}' is geen geldig e-mailadres`;
        return;
      }
      this.tagError = null;
      this.addRecipient({ email: email, label: email });
    },
    formatHistorieDatum(value) {
      return this.moment(value).format("LLL");
    },
    // Laatste SendGrid event voor een specifiek e-mailadres binnen een verzending
    laatsteEventVoor(verzending, adres) {
      var events = (verzending.Events || []).filter(
        (e) => (e.Email || "").toLowerCase() === adres.toLowerCase()
      );
      if (events.length === 0) return null;
      return events[events.length - 1];
    },
    eventVariant(eventType) {
      switch ((eventType || "").toLowerCase()) {
        case "delivered":
        case "open":
        case "opened":
        case "click":
          return "success";
        case "processed":
        case "deferred":
          return "info";
        case "bounce":
        case "bounced":
        case "dropped":
        case "spamreport":
          return "danger";
        default:
          return "light";
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    DocumentVerwijderen() {
      var vm = this;
      vm.isBusy = true;
      this.delete(this.docEndpoint)
        .then(() => {
          vm.$emit("delete-row", this.id);
          vm.$router.push({ name: "Documenten", params: { jaar: new Date().getFullYear() } });
        })
        .finally(() => {
          vm.isBusy = false;
        });
    },
    DocumentOpslaan() {
      var vm = this;
      vm.isBusy = true;
      this.put(this.docEndpoint, this.details)
        .then((response) => {
          vm.details = response.data.details;
          var row = response.data.details;
          var rowUpdateData = {
            Id: row.Id,
            Re: row.RelatieBedrijf ? row.RelatieBedrijf.Naam : row.Relatie.Naam,
            Af: row.Afzender.Naam,
            Ty: row.Type.Omschrijving,
            Da: row.Datum,
            Be: row.Bedrag,
            Ve: row.Verzenddatum,
            So: row.SoortOnderhoud,
            Zi: row.DocumentTonen,
            Sc: row.Status.Id,
            St: row.Status.Omschrijving,
            Un: row.Units.map((u) => `${u.adres} ${u.Plaats}`).join(", "),
            Ke: row.Kenmerk,
            Cl: row.FileMetadata,
          };
          vm.$emit("update-row", rowUpdateData);
        })
        .finally(() => {
          vm.isBusy = false;
        });
    },
    VerwijderBijlagen(index) {
      this.details.Details.Bijlagen.splice(index, 1);
      this.DocumentOpslaan();
    },
    async getOriginalPdf() {
      const existingPdfBytes = await fetch(
        this.details.FileMetadata.secure_url
      ).then((res) => res.arrayBuffer());
      //  const PDFDocument
      return await PDFDocument.load(existingPdfBytes);
    },
    AddUnits(ids) {
      this.UnitsToevoegen(ids);
    },
    UnitsToevoegen(ids) {
      var vm = this;
      this.post(this.docEndpoint + "/units", { toetevoegen: ids })
        .then(function (response) {
          vm.details.Units = response.data.units;
        })
        .catch(function (error) {
          vm.error = error;
        })
        .finally(() => (vm.busy = false));
    },
    UnitsVerwijderen() {
      var vm = this;
      this.deletePost(this.docEndpoint + "/units", {
        teverwijderen: this.selectie.map((i) => i.Id),
      })
        .then(function (response) {
          vm.details.Units = response.data.units;
        })
        .catch(function (error) {
          vm.error = error;
        })
        .finally(() => (vm.busy = false));
    },

    async getPdf() {
      const pdfDoc = await this.getOriginalPdf();
      const font = await pdfDoc.embedFont(StandardFonts.Courier);

      if (this.heeftStempel) {
        const stempelURL = this.stempels[this.details.Status.Omschrijving];
        const stempelText = this.moment(this.details.Verzenddatum).format("LL");
        const stempelPNG = await fetch(stempelURL).then((res) =>
          res.arrayBuffer()
        );
        const stempel = await pdfDoc.embedPng(stempelPNG);

        //stempelen
        pdfDoc.getPages().forEach((element) => {
          this.stampPage(element, stempelText, stempel, font);
        });
      }

      return pdfDoc;
    },

    stampPage(page, text, stamp, font) {
      const textWidth = font.widthOfTextAtSize(text, this.fontSize);
      page.moveTo(this.left, this.bottom);
      page.drawImage(stamp, { opacity: this.opacity });
      page.drawText(text, {
        opacity: this.opacity,
        size: this.fontSize,
        x: stamp.width / 2 - textWidth / 2 + this.left,
        y: 7 + this.bottom,
      });
    },

    async previewFile() {
      const pdfDoc = await this.getPdf();
      const pdfDataUri = pdfDoc.saveAsBase64({ dataUri: true });
      this.renderedDoc = await pdfDataUri;
    },

    async sendFileWithStamp() {
      var vm = this;
      var filename = vm.details.FileMetadata.original_filename + ".pdf";

      this.boodschap = null;
      this.sending = true;

      //  const PDFDocument
      const pdfDoc = await this.getPdf();

      var pdfblob = new Blob([await pdfDoc.save()], {
        type: "application/pdf",
      });

      var formdata = new FormData();

      // gestempeld document
      formdata.append("doc", pdfblob, filename);

      // email velden
      formdata.append("to", vm.recipients);
      formdata.append("subject", vm.mail.onderwerp);
      formdata.append("body", vm.mail.bericht);

      vm.postMultipart(this.docEndpoint + "/versturen", formdata)
        .then(function (res) {
          vm.boodschap = res.data.details;
          // verzendhistorie kan bijgewerkt zijn — herlaad document details
          vm.getDocumentDetails();
        })
        .catch(function (error) {
          console.log(error);
          vm.boodschap = error;
        })
        .finally(function () {
          vm.sending = false;
        });
    },
    // InspecteurSelect geeft {id, naam} terug; map naar het API formaat {Id, Naam}
    onBeoordelaarInput(selectie) {
      this.$set(
        this.details,
        "Beoordelaar",
        selectie ? { Id: selectie.id, Naam: selectie.naam } : null
      );
    },
    getProfile() {
      var vm = this;
      this.get("/user/profile")
        .then(function (response) {
          vm.profiel = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeRelatie(relatie) {
      // contactpersoon deselecteren
      this.$set(this.details, "Relatie", null);
      this.getContactpersonen(relatie);
    },
    getContactpersonen(b) {
      console.log(b);
      var vm = this;
      this.fetchingContactpersonen = true;
      this.get(`/relatie/${b.Id}/contactpersonen`)
        .then(function (response) {
          vm.contactpersonen = response.data.contactpersonen;
        })
        .catch(function (error) {
          console.log(error);
          console.log("Error on Authentication");
        }).finally(() => (vm.fetchingContactpersonen = false));
    },
    updateEmail() {
      this.$set(this.mail, "bericht", this.bericht);
      this.$set(this.mail, "onderwerp", this.onderwerp);
    },
    getDocumentDetails() {
      var vm = this;
      this.get(this.docEndpoint).then((response) => {
        vm.details = response.data.details;
        vm.updateEmail();
        if (vm.details.Relatie)
          vm.getContactpersonen(vm.details.Relatie.Bedrijf);
        // Autofill uitvoeren zodra alle document data (units + relatie config) geladen is
        vm.$nextTick(() => vm.applyAutofillRoutes());
      });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
/* Dark mode overrides voor vue-multiselect */
.multiselect__tags,
.multiselect__input,
.multiselect__single {
  background: #2f353a;
  color: #e4e7ea;
  border-color: #23282c;
}

.multiselect__input::placeholder,
.multiselect__placeholder {
  color: #73818f;
}

.multiselect__content-wrapper {
  background: #2f353a;
  color: #e4e7ea;
  border-color: #23282c;
}

.multiselect__option {
  color: #e4e7ea;
}

.multiselect__option--highlight {
  background: #20a8d8;
  color: #fff;
}

.multiselect__option--highlight::after {
  background: #20a8d8;
  color: #fff;
}

.multiselect__option--selected {
  background: #23282c;
  color: #e4e7ea;
}

.multiselect__tag {
  background: #20a8d8;
  color: #fff;
}

.multiselect__tag-icon:hover {
  background: #1985ac;
}

.multiselect__select::before {
  border-color: #e4e7ea transparent transparent;
}

.multiselect--active .multiselect__tags {
  border-color: #20a8d8;
}
</style>
